import QuizzerScreen from './quizzer-screen';

export default QuizzerScreen;
